import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[decimalonly]',
    host: {
        '(input)': 'onInputChange()',
    },
})
export class DecimalOnlyDirective {
    constructor(public model: NgControl) {}

    onInputChange() {
        //var newValue = this.model.value.toUpperCase();
        let newValue: string = this.model.value.replace(/[^0-9\.]/g, '');
        if (newValue.indexOf('.') != newValue.lastIndexOf('.')) {
            //12.5.
            newValue = newValue.substring(0, newValue.length - 1);
        }
        this.model.valueAccessor.writeValue(newValue);
        this.model.viewToModelUpdate(newValue);
    }
}
